(() => {
  if (window.__giestoArketProduct) return;
  window.__giestoArketProduct = true;
  // Keep the existing 2:3 frame in place while a photo loads. Cached images
  // and the first/LCP photo paint immediately; later photos reveal softly.
  function prepareMedia(root = document) {
    for (const image of root.querySelectorAll('.gap--reference .gap__frame .gap__zoom-trigger img')) {
      if (image.dataset.gapLoadingReady) continue;
      image.dataset.gapLoadingReady = 'true';
      const frame = image.closest('.gap__frame');
      const finish = failed => {
        frame.classList.remove('is-media-loading');
        frame.classList.toggle('has-media-error',failed);
        frame.classList.add('is-media-ready');
        frame.removeAttribute('aria-busy');
        if (failed) frame.dataset.mediaError = document.documentElement.lang.startsWith('tr') ? 'Görsel yüklenemedi' : 'Image unavailable';
      };
      if (image.complete) {finish(!image.naturalWidth);continue;}
      frame.classList.add('is-media-loading');frame.setAttribute('aria-busy','true');
      image.addEventListener('load', () => {
        if (frame === frame.parentElement.firstElementChild) {finish(false);return;}
        // Decode before revealing a later image, without blocking the LCP image.
        Promise.resolve(image.decode?.()).catch(()=>{}).then(()=>finish(false));
      },{once:true});
      image.addEventListener('error',()=>finish(true),{once:true});
    }
  }
  prepareMedia();
  const mountPhoto = template => {
    const frame = template.closest('.gap__frame');
    const image = template.content.querySelector('img');
    if (image) image.loading = 'eager';
    template.replaceWith(template.content);
    if (frame) prepareMedia(frame.parentElement);
  };
  const photoObserver = new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) {
      const template = entry.target.querySelector('template[data-gap-deferred-image]');
      if (template) mountPhoto(template);
      photoObserver.unobserve(entry.target);
    }
  }, {rootMargin:matchMedia('(max-width:749px)').matches ? '0px 0px -80px 0px' : '150px'});
  const observePhotos = (root = document) => {
    for (const template of root.querySelectorAll('template[data-gap-deferred-image]')) {
      const frame = template.closest('.gap__frame');
      frame.classList.add('is-media-loading');frame.setAttribute('aria-busy','true');
      photoObserver.observe(frame);
    }
  };
  // Zoom deliberately mounts the entire gallery; normal browsing loads only
  // frames close to view, instead of the browser's much larger lazy threshold.
  window.GiestoProductMedia = {mount:root=>root.querySelectorAll('template[data-gap-deferred-image]').forEach(mountPhoto)};
  observePhotos();
  document.addEventListener('shopify:section:load',event=>{prepareMedia(event.target);observePhotos(event.target);});
  const identity = p => String(p.id || '').replace('gid://shopify/Product/', '');
  async function renderColors(container, source) {
    let group = window.GiestoColorGroups.match(container, source);
    const root = container.closest('giesto-store-product');
    const requestedProduct = container.dataset.p;
    if (root?.dataset.season === 'fw27') {
      const order = await window.GiestoColorGroups.seasonOrder();
      if (requestedProduct !== container.dataset.p || !container.isConnected) return;
      group = { ...group, products: window.GiestoColorGroups.orderProducts(group.products, order) };
    }
    const current = group.products.find(p => identity(p) === container.dataset.p);
    const trigger = root?.querySelector('[data-gap-colour-groups-trigger]');
    if (!current || !trigger) return;
    const singleColor = root.querySelector('[data-gaa-single-color]');
    if (singleColor && current.colorCode) singleColor.firstElementChild.style.background = current.colorCode;
    const hasLinkedColors = group.products.length > 1;
    // A confirmed linked family supplies the same choices on every color page.
    // Retain native variants when no family resolves, including app failures.
    const nativeColors = root.querySelector('[data-gap-native-colors]');
    if (nativeColors) nativeColors.hidden = hasLinkedColors;
    if (singleColor) singleColor.hidden = hasLinkedColors;
    trigger.hidden = !hasLinkedColors;
    trigger.querySelector('.gap__colour-label').textContent = `${current.color || container.dataset.productColor || ''}${group.products.length > 1 ? ' +' + (group.products.length - 1) : ''}`;
    trigger.querySelector('.gap__colour-swatch').style.backgroundColor = current.colorCode || '#888';
    const grid = document.createElement('div');grid.className = 'ga-product-colors';
    for (const product of group.products) {
      const link = document.createElement('a');link.href = `${(container.dataset.root || '/').replace(/\/$/, '')}/products/${product.handle}`;
      const selected = identity(product) === container.dataset.p;
      if (selected) link.setAttribute('aria-current', 'true');
      const src = product.image || product.featuredImage?.url;
      if (src) {
        const img = document.createElement('img');
        // These are small drawer thumbnails, not zoom images. Set lazy loading
        // before src so WebKit doesn't fetch full originals while it is closed.
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = product.color || '';
        const thumbnail = new URL(src, location.href);
        if (/\/cdn\/shop\/files\//.test(thumbnail.pathname) ||
            (thumbnail.hostname === 'cdn.shopify.com' && /\/files\//.test(thumbnail.pathname))) {
          thumbnail.searchParams.set('width', '600');
        }
        img.src = thumbnail.href;
        link.append(img);
      }
      const label = document.createElement('span');label.textContent = product.color || product.title;link.append(label);
      if (product.availableForSale === false) link.classList.add('is-sold-out');
      grid.append(link);
    }
    container.replaceChildren(grid);
  }
  function scan() {
    const pc = window.CSGA?.PC;
    if (!pc?.render || !window.GiestoColorGroups) return false;
    if (!pc.__giestoProduct) {
      const original = pc.render;
      pc.render = function(container, group) {
        if (container.closest('[data-gap-colour-groups]')) return renderColors(container, group);
        return original.call(this, container, group);
      };
      pc.__giestoProduct = true;
    }
    document.querySelectorAll('[data-gap-colour-groups] .csga-pc').forEach(e => { e.replaceChildren(); delete e.dataset.loaded; });
    pc.scan();return true;
  }
  if (!scan()) {
    const app = document.createElement('script');app.src = '/apps/renk-grubu/pc.js?v=2';app.async = true;app.addEventListener('load', scan, {once:true});document.head.append(app);
  }
  // Use the existing gallery images in an accessible full-screen viewer.
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-gap-zoom]');if (!trigger) return;
    const product = trigger.closest('giesto-store-product');
    const images = [...product.querySelectorAll('[data-gap-zoom] img')];
    const index = images.indexOf(trigger.querySelector('img'));
    let dialog = product.querySelector('.ga-product-zoom');
    if (!dialog) {
      dialog = document.createElement('dialog');dialog.className = 'ga-product-zoom';dialog.setAttribute('aria-label', trigger.getAttribute('aria-label'));
      const close = document.createElement('button');close.type = 'button';close.className = 'ga-product-zoom__close';close.setAttribute('aria-label', document.documentElement.lang === 'tr' ? 'Kapat' : 'Close');close.textContent = '×';close.onclick = () => dialog.close();
      const track = document.createElement('div');track.className = 'ga-product-zoom__track';
      for (const image of images) { const large = image.cloneNode();large.removeAttribute('sizes');large.removeAttribute('srcset');large.loading = 'lazy';large.alt = image.alt;track.append(large);}
      dialog.append(close, track);product.append(dialog);
      dialog.addEventListener('close', () => trigger.focus({preventScroll:true}));
    }
    dialog.showModal();
    const track = dialog.querySelector('.ga-product-zoom__track');
    requestAnimationFrame(() => {track.scrollLeft = index * track.clientWidth;});
  });
})();
